// 試算の燃費 設定ローダー（2026-08-28）。settings/assumptions の
// {quoteKmLMedium, quoteKmLLarge, dieselYen} を読み、quoteFuel.core.js のストアへ流し込む。
// 流儀は laborRates.js（settings/labor → setLabor）と同じ。
// ⚠️ 同じドキュメントの kmL（**実績**の燃費上書き）はここでは読まない＝試算へ持ち込まない。
//    役割の境界は quoteFuel.core.js 冒頭を参照。
import { COLLECTIONS, getOne } from './collections.js'
import { setQuoteFuel } from './quoteFuel.core.js'
import { supabaseReady } from '../supabase.js'

let _at = 0
const TTL = 60 * 1000

export function invalidateQuoteFuel() { _at = 0 }

// 起動時（main.js）と前提パネルの保存後（dashboard.js）に呼ぶ。失敗しても既定（中型4・大型2）で動く。
export async function refreshQuoteFuel(force) {
  if (!supabaseReady) { setQuoteFuel(null); return null }
  if (!force && _at && (Date.now() - _at) < TTL) return null
  try {
    const s = await getOne(COLLECTIONS.settings, 'assumptions')
    setQuoteFuel(s || null)
    _at = Date.now()
    return s || null
  } catch { setQuoteFuel(null); return null }
}
